import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { KanbanViewCardI, KanbanViewListI } from '../../models/kanban-view/kanban-order-viewI';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { KanbanProductionMachineDialogComponent } from '../kanban-production-machine-dialog/kanban-production-machine-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { KanbanAddEditSwimLaneComponent } from '../kanban-add-edit-swimlane/kanban-add-edit-swimlane.component';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'anterasoftware-orders-kanban-view-container',
  templateUrl: './orders-kanban-view-container.component.html',
  styleUrls: ['./orders-kanban-view-container.component.scss']
})
export class OrdersKanbanViewContainerComponent implements OnInit {

  @Input() public swimLaneList: KanbanViewListI[] = [];
  @Input() public equipments: any[] = [];
  @Output() public updateOrderStatus: EventEmitter<any> = new EventEmitter();
  @Output() public onSwimLaneChange: EventEmitter<any> = new EventEmitter();
  @Output() public onDeleteSwimLane: EventEmitter<any> = new EventEmitter();
  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Input() public dateFormatString: string = 'YYYY-MM-DD';
  @Input() public timeFormatString: string = 'hh:mm a';
  public colorWarn = 'warn';
  public modeWarn = 'determinate';
  public valueWarn = 65;
  public bufferValueWarn = 85;

  public color = 'success';
  public mode = 'determinate';
  public value = 50;
  public bufferValue = 75;
  

  constructor(
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
  }

  drop(event:any,swimLane:KanbanViewListI) {
    
    if(swimLane && swimLane.header && swimLane.header.title) {
      if(event && event.value) {
        event.value.kanbanStatus = swimLane.header.title;
      }
    }
    /* if(swimLane && swimLane.header && swimLane.header.title === 'Unscheduled Jobs') {
      console.log("hello here Unscheduled Jobs")
      let jobId = "";
        if(event.item && event.item.data) {
          jobId =  event.item.data.id
          
        }
        let job = {
          jobId: jobId,
          formValues: {
            machineId: "",
            scheduleDate: "",
          }
        }
        console.log("hello here Unscheduled Jobs job", job)
      this.onUpdateJob.emit(job)
    } else {
      let dialogRef = this.dialog.open(KanbanProductionMachineDialogComponent, {
      width: '400px',
      height: '350px',
      data: {
        equipments: this.equipments,
        machineId: event.item.data.machineId
      },
    });

    dialogRef.afterClosed().subscribe((formValues: any) => {
      let jobId = "";
      if(event.item && event.item.data) {
        jobId =  event.item.data.id
        
      }
      if(formValues &&  formValues.machineId !="") {
        let job = {
          jobId: jobId,
          machineId: formValues.machineId,
          scheduleDate: swimLane.header.scheduleDate
        }
        this.onUpdateJob.emit(job)
      }
    }); */
    if(event && event.value) {
      let dropped =  {
        order: event.value,
        swimLane: swimLane
      }
      this.updateOrderStatus.emit(dropped);
    }
  //}
    /* if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
                        event.container.data,
                        event.previousIndex,
                        event.currentIndex);
    }
    
    
    if(event.item && event.item.data) {
      let dropped =  {
        status: swimLane,
        artwork: event.item.data
      }
      
      this.onDrop.emit(dropped);
    } */
    
  }

  public openSwimLaneDialog(panel?: KanbanViewListI) {
    let dialogRef = this.dialog.open(KanbanAddEditSwimLaneComponent, {
      width: '500px',
      height: '450px',
      panelClass: 'antera-details-dialog',
      data: {
        panel: panel,
        swimlaneLength: this.swimLaneList.length
      },
    });

    dialogRef.afterClosed().subscribe((formValues: any) => {

      if (formValues) {
        /* this.onSwimLaneChange.emit(formValues);
        if (panel) {
          const foundPanelIndex = this.swimLaneList.findIndex((panel: KanbanViewListI) => panel.id === formValues.id);

          if(foundPanelIndex !== -1){
            this.swimLaneList[foundPanelIndex].header.title = formValues.title;
            // todo: ask about this property from the modal
            // this.swimLaneList[foundPanelIndex].header.totalType = formValues.totalType;
          }

        } else {
          // todo remove id eventually
          const newSwimLane = {
            id: String(Math.random()),
            header: { title: formValues.title },
          } as KanbanViewListI;

          const swimLaneLength = this.swimLaneList.length;

          this.swimLaneList.splice(swimLaneLength - 1, 0, newSwimLane);
        } */

        this.onSwimLaneChange.emit(formValues);
      }
    });
  }

  public cardValueChange(card: KanbanViewCardI, swimLaneIndex: number, cardIndex: number){
    // don't need this ngModel handles
    // this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    //this.onSwimLaneChange.emit(this.swimLaneList);
    this.swimLaneList[swimLaneIndex].cards[cardIndex] = card;
    this.selectClicked.emit(this.swimLaneList);
  }

  public deleteSwimLane(swimlane?: KanbanViewListI) {
    this.onDeleteSwimLane.emit(swimlane);
  }

  public onToggleAll(event: MatCheckbox, swimLaneIndex: number){
    this.swimLaneList[swimLaneIndex]?.cards.forEach((card: KanbanViewCardI) => card.select = event.checked);
    this.selectClicked.emit(this.swimLaneList);
  }
}
